/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  ReactComponent as SearchIcon
} from '@pagerduty/design-system/dist/icons/search.svg';

import {
  currentUserAddons,
  currentUserData
} from '../../features/fe-data/selectors';
import getPermissions from '../NavbarVariants/permissions';

import NavbarLink from './NavbarLink';
import NavbarDropdownList from './NavbarDropdownList';
import NavbarDropdownRight from './NavbarDropdownRight';
import NavbarDropdownHeader from './NavbarDropdownHeader';
import NavbarDropdownListItem from './NavbarDropdownListItem';
import NewNavToggler from '../NewNavToggler';
import Logo from '../Logo';

import './LegacyNavbar.css';

export const LegacyNavbarComponent = ({
  permissions,
  addons,
  user
}) => {
  const leftNavItems = () => (
    <React.Fragment>
      {permissions.changeEvents
        ? (
          <NavbarDropdownList label="Incidents">
            <NavbarDropdownListItem label="Incidents" />
            <NavbarDropdownListItem label="Recent Changes" badge="beta" />
          </NavbarDropdownList>
        )
        : <NavbarLink label="Incidents" />
      }

      {permissions.alerts && <NavbarLink label="Alerts" />}

      <NavbarDropdownList label="Configuration">
        <NavbarDropdownListItem label="My On-Call Shifts" badge="new" />

        <NavbarDropdownListItem label="Escalation Policies" />

        {permissions.schedules && <NavbarDropdownListItem label="Schedules" />}

        {permissions.serviceDirectory
          ? <NavbarDropdownListItem label="Service Directory" />
          : <NavbarDropdownListItem label="Services" />
        }

        {permissions.serviceIntelligence && <NavbarDropdownListItem label="Service Intelligence" badge="beta" />}

        {permissions.eventIntelligence && <NavbarDropdownListItem label="Event Intelligence" />}

        {permissions.eventRules && <NavbarDropdownListItem label="Event Rules" />}

        {permissions.responsePlays && <NavbarDropdownListItem label="Response Plays" />}

        <NavbarDropdownListItem label="Business Services" />

        {permissions.impactMetrics && <NavbarDropdownListItem label="Impact Metrics" />}

        <NavbarDropdownListItem label="Users" />

        {permissions.teams && <NavbarDropdownListItem label="Teams" />}

        {permissions.onCallReadiness && <NavbarDropdownListItem label="On-Call Readiness" badge="new" />}

        {permissions.apiAccess && <NavbarDropdownListItem label="API Access" />}

        {permissions.isNotRestrictedAccess && <NavbarDropdownListItem label="Extensions" />}

        {permissions.accountSettings
          && <NavbarDropdownListItem label="Account Settings" link={permissions.ownerAccountSettings ? '/account/settings' : '/account/incident_priorities'} />}

        {permissions.adminDashboard && (
          <NavbarDropdownListItem label="License Administration" />
        )}

      </NavbarDropdownList>

      <NavbarDropdownList label="Analytics">

        {permissions.operationsHealth && <NavbarDropdownListItem label="Operations Health" />}

        {permissions.isNotRestrictedAccess && permissions.operationalReviews && (
          <NavbarDropdownListItem label="Operational Reviews" />
        )}

        {permissions.isNotRestrictedAccess && permissions.analyticsDashboards && (
          <NavbarDropdownListItem label="Intelligent Dashboards" />
        )}

        {permissions.reports && (
          <React.Fragment>
            <NavbarDropdownListItem label="Notification Volume" />
            <NavbarDropdownListItem label="Incident Volume" />
          </React.Fragment>
        )}

        {permissions.advancedReports && (
          <React.Fragment>
            <NavbarDropdownListItem label="System Report" />
            <NavbarDropdownListItem label="Team Report" />
            <NavbarDropdownListItem label="User Report" />
          </React.Fragment>
        )}

        {permissions.reportsPreview && (
        <React.Fragment>
          <NavbarDropdownListItem label="System Report (Preview)" />
          <NavbarDropdownListItem label="Team Report (Preview)" />
          <NavbarDropdownListItem label="User Report (Preview)" />
        </React.Fragment>
        )}

        {permissions.postmortems
          ? <NavbarDropdownListItem label="Postmortems" />
          : <NavbarDropdownListItem label="Postmortems (Preview)" />}

        {permissions.isNotRestrictedAccess && permissions.pdLabs && (
          <NavbarDropdownListItem label="PD Labs" badge="beta" />
        )}

      </NavbarDropdownList>

      {addons.length > 0 && (
        <NavbarDropdownList label="Add-Ons">
          {addons.map(a => <NavbarDropdownListItem key={a.id} label={a.name} link={a.html_url} />)}
        </NavbarDropdownList>
      )}

      {permissions.visibility && <NavbarLink label="Visibility" badge="new" />}

      {permissions.statusPage && <NavbarLink label="Status" link={permissions.bisStatusPage ? '/statusdashboard' : '/status-dashboard'} />}

      {permissions.globalSearch && (
        <li className="nav-item global-search">
          <form method="GET" action="/search">
            <SearchIcon className="app-icon" height="20px" width="28px" style={{ marginTop: '-5px' }} />
            <input type="text" name="searchString" placeholder="Search..." />
          </form>
        </li>
      )}
    </React.Fragment>
  );

  return (
    <div className="legacy-navbar loaded">
      <nav className="navbar navbar-expand navbar-dark">
        <Logo />
        <ul className="mr-auto navbar-nav">
          {!permissions.currentUserReadOnlyLimited && leftNavItems()}
        </ul>
        {!permissions.currentUserReadOnlyLimited && permissions.appDirectory && (
          <NavbarDropdownRight>
            <NavbarDropdownHeader id="app_directory">
              <svg fill="#b3b3b3" className="app-icon" width="28" height="16" viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg">
                <g fillRule="evenodd">
                  <path d="M10 0h7.11v6.276H10zM10 9h7.11v6.276H10zM0 0h7.11v6.276H0zM0 9h7.11v6.276H0zM20 0h7.11v6.276H20zM20 9h7.11v6.276H20z" />
                </g>
              </svg>
            </NavbarDropdownHeader>
            <div tabIndex="-1" role="menu" left="true" aria-hidden="true" className="dark dropdown-menu dropdown-menu-right">
              <NavbarDropdownListItem label="Integrations Directory" />
              <NavbarDropdownListItem label="Developer Mode" />
            </div>
          </NavbarDropdownRight>
        )}

        <NavbarDropdownRight>
          <NavbarDropdownHeader id="question_mark">
            <span className="question-mark">?</span>
          </NavbarDropdownHeader>
          <div tabIndex="-1" role="menu" left="true" aria-hidden="true" className="dark dropdown-menu dropdown-menu-right">
            <NavbarDropdownListItem label="Help" />
            <NavbarDropdownListItem label="Contact Support" />
            <NavbarDropdownListItem label="Community Discussions" />
            <NavbarDropdownListItem label="What's New in PagerDuty" openNewTab />
            <NewNavToggler legacy />
          </div>
        </NavbarDropdownRight>

        <NavbarDropdownRight>
          <NavbarDropdownHeader id="avatar">
            <img src={user.avatarUrl} size="30" width="30" height="30" alt={user.name} title={user.name} />
          </NavbarDropdownHeader>
          <div tabIndex="-1" role="menu" left="true" aria-hidden="true" className="dropdown-menu dropdown-menu-right">
            <a className="dropdown-item">
              <div className="d-flex">
                {user.name}
                <br />
                {user.email}
              </div>
            </a>
            <NavbarDropdownListItem label="My Profile" link={`/users/${user.id}`} />
            <NavbarDropdownListItem label="Logout" />
          </div>
        </NavbarDropdownRight>
      </nav>
    </div>
  );
};

LegacyNavbarComponent.propTypes = {
  permissions: PropTypes.objectOf(PropTypes.bool).isRequired,
  addons: PropTypes.arrayOf(PropTypes.shape({
    addon_id: PropTypes.string,
    html_url: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  user: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    avatarUrl: PropTypes.string,
    id: PropTypes.string
  }).isRequired
};

const mapStateToProps = state => ({
  permissions: getPermissions(state),
  addons: currentUserAddons(state),
  user: currentUserData(state)
});

export default connect(mapStateToProps)(LegacyNavbarComponent);
